import { ButtonColor } from "@/common/enum/button-color";
import { PartnerOrderPath } from "@/common/enum/path";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { AngleRightOutlineIcon } from "../icon/AngleRightlineIcon";
import { Body14Regular } from "../typography/Body14Regular";
import { H4 } from "../typography/H4";

export const PartnerDiscountHeader = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PartnerOrderPath.ORDER);
  };
  return (
    <div className="py-[16px]">
      <div className="flex items-center justify-between py-[5px]">
        <div className="flex">
          <H4 className="text-semantic-text-heading">상품 할인</H4>
        </div>
        <Button
          size="xs"
          color={ButtonColor.TRANSPARENT_OUTLINE}
          onClick={handleClick}
        >
          <div className="flex items-center gap-[8px]">
            <Body14Regular>상품 발주하기</Body14Regular>
            <AngleRightOutlineIcon size={16} />
          </div>
        </Button>
      </div>
      <div />
    </div>
  );
};
